import { gql } from '@apollo/client'

export const CASES_QUERY = gql`
  query processings(
    $sortBy: ProcessingSort
    $filter: ProcessingFilter
    $page: Int
    $limit: Int
    $isAdmin: Boolean = false
    $creator: Boolean
    $months: Int
  ) {
    processings(
      sortBy: $sortBy
      filter: $filter
      page: $page
      limit: $limit
      creator: $creator
      months: $months
    ) {
      collection {
        id
        fileNumber
        poolId
        invoice {
          id
          invoiceNo
          invoiceDate
          sentAt
          invoiceSum
          clientPayment
          paidDeductible
          sumCosts
          agentId
          agent {
            name
          }
        }
        customerInvoice {
          id
          invoiceNo
          sentAt
          invoiceSum
          agentId
          agent {
            name
          }
        }
        feedbackRsvAt
        income
        additionalIncome
        additionalIncomeComments
        invoiceSettlementComments
        costsSettledWithRsvAt
        rsvBillable
        rsvNonBillableReason
        additionalCost
        paymentStatus
        payoutStatus
        payoutAddedAt
        transactionFee
        refundedAmount
        paymentMethod
        m2Case {
          priority
          identifier
          comments
          processingsCount
          forwardedCase
          legalAdvice
          coverageScope
          id
          settlementComments @include(if: $isAdmin)
          customerRating @include(if: $isAdmin)
          source
          handoverType
          caseState
          commentsPolicyholder
          commentsLegalAdvice
          insurance {
            title
          }
          hint
          creator {
            id
            name
          }
          creatorComments
          project {
            title
            callCenterLegalAdvice
            collisionDetectionEnabled
            reactionTimeInMinutes
          }
          policyholder {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
            communicationViaCustomerPortal
            casesCount
            policyNumber
            cases {
              id
              claimNumber
              assignedToM2At
            }
          }
          conflictPartner {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
          }
          conflictContact {
            salutation
            lastname
            firstname
            birthDate
            company
            street
            houseNumber
            postalCode
            place
            phoneNumber
            mobileNumber
            email
            comments
            relationToConflictPartner
          }
          contactPerson {
            id
            salutation
            lastname
            firstname
            phoneNumber
            mobileNumber
            email
            relationToPolicyholder
          }
          conflictPartnerFileNumber
          claimNumber
          claimDate
          assignedToM2At
          m2LegalArea {
            title
          }
          rsvLegalArea {
            title
          }
          comments
          followingM2Case {
            id
            identifier
          }
          previousM2Case {
            id
            identifier
          }
          cost @include(if: $isAdmin)
          additionalCost @include(if: $isAdmin)
          customerComments @include(if: $isAdmin)
          disputeValue
          deductible
          deductibleAmount
          costsSettledWithRsvAt @include(if: $isAdmin)
          evaluatedDailyAt
          evaluatedMonthlyAt
          rsvStatus
          statusReportSentAt @include(if: $isAdmin)
        }
        coverage
        agentId
        agent {
          name
          costCentre
          role @include(if: $isAdmin)
        }
        assignedFromId
        assignedFrom {
          name
          id
        }
        assignedAt
        acceptedAt
        canBeginAt
        processingStep
        processingState
        firstCallAt
        forwardedToRightmartAt
        closedAt
        closedByM2
        processingComments
        intendedProcessingType {
          title
          category
        }
        assignedProcessingType {
          title
          category
        }
        actualProcessingType {
          id
          title
          category
          callCenterLegalAdvice
        }
        documentsWereSent
        settlementRate
        settlementTypeId
        settlementType {
          title
        }
        closingTypeId
        closingType {
          title
        }
        result
        closingResultLevel1Title
        closingResultLevel2Title
        closingResultLevel3Title
        closedByRsv
        feedbackRsvAt
        costsSettledWithOperatorAt @include(if: $isAdmin)
        cost @include(if: $isAdmin)
        additionalCost @include(if: $isAdmin)
        costsCoveredByKp @include(if: $isAdmin)
        receivedPayment @include(if: $isAdmin)
        settlementComments @include(if: $isAdmin)
        closingComments
        coverage
        policyholderContactedAt
        coverageRequestedAt
        forwardedToRightmartAt
        coverageComments
        date1
        date2
        statusReportSentAt @include(if: $isAdmin)
        lastActionAt
        nextTaskAt
        nextTaskComment
        canBeginAt
        firstCallDelayed
        agentFit
        goalPolicyholderWants
        goalPolicyholderSolutions
        goalConflictPartnerWants
        goalConflictPartnerSolutions
        finalReportUrl
        finalReportSentAt
        createdAt
        updatedAt
      }
      metadata {
        totalCount
        currentPage
      }
    }
  }
`
